<template>
	<div>
		<Modal v-model="modal.ifShow" :title="modal.Title" width="30%" :mask-closable="false" :closable="false">
			<!--控件添加修改-->
			<Form :rules="ruleInline" label-position="right" v-if="modal.type=='add'||modal.type=='up'" ref="refForm"
				:model="modalInfo" :label-width="90">
				<Row v-show='false' :gutter="24" style="margin-bottom: 10px;">
					<Col span=6>
					<FormItem label="事件Id" prop="Name">
						<Input :disabled="modal.Id" v-model="modalInfo.Id" placeholder="事件Id"></Input>
					</FormItem>
					</Col>
					<Col span=6>
					<FormItem label="场站ID" prop="StationId">
						<Input :disabled="modal.canInput" v-model="modalInfo.StationId" placeholder="场站ID"></Input>
					</FormItem>
					</Col>
					<Col span=6>
					<FormItem label="事件代码" prop="EventCode">
						<Input :disabled="modal.canInput" v-model="modalInfo.EventCode" placeholder="事件代码"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24" style="margin-bottom: 10px;">
					<Col span=12>
					<FormItem label="场站名字" prop="StationId">
						<Select :disabled="modal.canInput" placeholder="站点列表" v-model="modalInfo.StationId">
							<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">
								{{item.StationName}}
							</Option>
						</Select>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem label="事件描述" prop="EventCode">
						<Select :disabled="modal.canInput" placeholder="事件描述" v-model="modalInfo.EventCode">
							<Option v-bind:key="item.Id" v-for="(item) in EventList" :value="item.Id">
								{{item.Name}}
							</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<Col span=12>
					<FormItem label="时间" prop="EventTime">
						<DatePicker :disabled="modal.canInput" type="datetime" v-model="modalInfo.EventTime"
							placeholder="时间"></DatePicker>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem label="备注" prop="Remark">
						<Input :disabled="modal.canInput" v-model="modalInfo.Remark" placeholder="备注"></Input>
					</FormItem>
					</Col>
				</Row>
			</Form>
			<div v-if="modal.type=='add'" slot="footer">
				<Button type="warning" size="large" @click="modalOk('cancle')">{{ $t('Common.Cancel') }}</Button>
				<Button type="success" size="large" @click="modalOk('add')">{{ $t('Common.Add') }}</Button>
			</div>
			<div v-if="modal.type=='up'" slot="footer">
				<Button type="warning" @click="modalOk('cancle')" size="large">{{ $t('Common.Cancel') }}</Button>
				<Button type="success" @click="modalOk('up')" size="large">{{ $t('Common.Edit') }}</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import dateFormat from '../../../../../public/js/comm.js'
	import webapi from '../../../../webapi.js';
	export default {
		data() {
			return {
				modal: {
					Title: "事件添加",
					type: "add",
					ifShow: false,
					canInput: false
				},
				
				modalInfo: {
					// 事件Id
					// 场站ID
					// 场站名字
					// 事件代码
					// 事件描述
					// 时间
					// 备注
					Id: 0,
					StationId: "",
					StationName: "",
					EventCode: "",
					EventDesc: "",
					EventTime: "",
					Remark: ""
				},
				/****************/
				upHeader: {
					'Authorization': "Bearer " + encodeURIComponent(localStorage.AccessToken)
				},
				// Validate Fields
				ruleInline: {
					// Name: [{
					// 	validator: validateOpId,
					// 	trigger: 'blur',
					// }],
					StationId: [{
						required: true,
						message: '控件名称',
						trigger: 'change',
						type: 'number'
					}],
					EventCode: [{
						required: true,
						message: '显示名称',
						trigger: 'change',
						type: 'number'
					}],
				},
			};
		},

		methods: {
			
			show: function(type, params) {
				const _this = this;
				if (type == "add") {
					_this.modal.Title = "事件添加";
					_this.modal.type = "add";
					_this.$refs.refForm.resetFields()
				} else if (type == "up") {
					_this.modal.Title = "事件修改";
					_this.modal.type = "up";
					_this.modalInfo = Object.assert({}, ...params)
				}
				_this.modal.ifShow = true
			},
			
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case 'cancle':
						_this.modal.ifShow = false
						break;
					case 'add':
						_this.modal.ifShow = true
						_this.addAndUp('add');
						break;
					case 'up':
						_this.modal.ifShow = true
						_this.addAndUp('up');
						break;
					default:
						break;
				}
			},
			
			addAndUp: function(type) {
				const _this = this;
				_this.$refs.refForm.validate((valid) => {
					console.log("事件" + type + "----" + valid)
					if (valid) {
						let parms = {
							"StationId": this.modalInfo.StationId,
							"EventCode": this.modalInfo.EventCode,
							"EventTime": dateFormat.formatDate(this.modalInfo.EventTime, 'yyyy-MM-dd'),
							"Remark": this.modalInfo.Remark
						}
						_this.$axios.post(webapi.base_api_url + "/Archives/AddEventInfo", parms, {}).then(
							res => {
								console.log("新增事件")
								console.log(res.data)
								if (res.data.Code == 0) {
									this.$Message.success('新增事件成功');
									_this.$emit('handleSubmit');
									_this.modalOk("cancle")
								} else {
									this.$Message.error(res.data.Msg + "---" + res.data.Data);
								}
							})
					}
				})
			},
			/**********Component Method*********/
			handleView(name) {
				this.imgName = name;
				this.visible = true;
			},
			handleRemove(file) {
				console.log(file)
				const _this = this
				if (_this.PictureDelCache.indexOf(file.name) > 0) {
					console.log('Delete cache ')
				} else {
					console.log('Cache is not exist')
					_this.PictureUpCache.push(file.name)
				}
				const fileList = _this.$refs.upload.fileList;
				_this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
				_this.$nextTick(() => {
					
					_this.uploadList = _this.$refs.upload.fileList
					_this.defaultList = _this.$refs.upload.fileList
				})
				_this.StationPicturesArray = _this.StationPicturesArray.filter(function(item, index,
					arr) {
					console.log(file.name)
					return item != file.name
				})
			},
			handleSuccess(res, file) {
				if (res.Code == 0) {
					file.url = webapi.base_api_url + res.Data;
					file.name = res.Data;
					let itemLen = this.defaultList.length;
					this.$set(this.defaultList, itemLen, file);
					this.uploadList = this.defaultList
					this.StationPicturesArray.push(file.name)
					this.PictureDelCache.push(file.name)
				}
				//file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar';
				//file.name = '7eb99afb9d5f317c912f08b5212fd69a';
			},
			handleFormatError(file) {
				this.$Notice.warning({
					title: this.$t('Common.FormatError'),
					desc: this.$t('Common.SelectJpgOrPng')
				});
			},
			handleMaxSize(file) {
				this.$Notice.warning({
					title: this.$t('Common.ImageTooLarge'),
					desc: this.$t('Common.File') + file.name + ' '+this.$t('Common.SelectSmallerImg')
				});
			},
			handleBeforeUpload() {
				const check = this.uploadList.length < 5;
				if (!check) {
					this.$Notice.warning({
						title: 'Up to five pictures can be uploaded.'
					});
				}
				return check;
			},
			OperatorNameChange: function(a) {
				console.log(a)
				this.StationForm.OperatorId = a;
			}
		},
		mounted() {
			this.upHeader.Authorization = "Bearer " + encodeURIComponent(localStorage.AccessToken);
		},
		computed: {

			...mapState({
				StationList: 'Stations',
				EventList: 'EventList'
			})
		}
	}
</script>

<style>
</style>
